import React from 'react'
import useTheme from 'hooks/useTheme'
import { useTranslation } from 'contexts/Localization'
import { Text, CloseIcon, ArrowBackIcon } from 'vvs-uikit'
import styled from 'styled-components'
import { DescTextStyles } from './BoostFarmQAContent'

const Header = styled.div`
  padding: 24px 24px 40px 24px;
  background: linear-gradient(90deg, #002966 0%, #9476bd 75.91%, #be8e96 100%);
  min-height: 190px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-end;
  position: relative;
`

const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  font-size: 28px;
  line-height: 36px;
  font-family: 'Effra';
  display: flex;
  align-items: center;
  :after {
    content: 'NEW';
    width: 54px;
    height: 30px;
    background-color: ${({ theme }) => theme.colors.primary};
    padding: 6px 12px;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    margin-left: 8px;
  }
`

const SubTitle = styled(Text)`
  ${DescTextStyles}
  color: ${({ theme }) => theme.colors.white};
`

const BoostMole = styled.img`
  position: absolute;
  top: 24px;
  right: 55px;
  width: 254px;
  display: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: inline-block;
  }
`

const StyledCloseButton = styled(CloseIcon)`
  width: 24px;
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`

const StyledArrowBackIcon = styled(ArrowBackIcon)`
  width: 24px;
  position: absolute;
  top: 24px;
  left: 24px;
  cursor: pointer;
`

const BoostFarmQAHeader: React.FC<{
  hideCloseButton?: boolean
  onCloseBtnClick?: () => void
  hideBackPrevButton?: boolean
  onBackPrevBtnClick?: () => void
}> = ({ hideCloseButton = false, onCloseBtnClick, hideBackPrevButton = false, onBackPrevBtnClick }) => {
  const { theme } = useTheme()
  const { t } = useTranslation()

  return (
    <Header>
      <Title>{t('xVVS and Miner Moles NFT Boost')}</Title>
      <SubTitle>
        {t(
          'Now you can boost LP token farming by staking both xVVS and NFT. So there will be double rewards you can earn!',
        )}
      </SubTitle>
      <BoostMole src="/images/xVVS/boost_mole.png" alt="boost_mole" />
      {!hideCloseButton && <StyledCloseButton fill={theme.colors.white} onClick={onCloseBtnClick} />}
      {!hideBackPrevButton && <StyledArrowBackIcon fill={theme.colors.white} onClick={onBackPrevBtnClick} />}
    </Header>
  )
}

export default BoostFarmQAHeader
